"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var EmploymentItem_1 = require("./parts/EmploymentItem");
var validations_1 = require("lib/functions/validations");
var findErrors_1 = require("lib/functions/findErrors");
var validate_js_1 = __importDefault(require("validate.js"));
var moment_1 = __importDefault(require("moment"));
var datetime = validations_1.date.datetime;
var rules = {
    company1_name: validations_1.mandatory,
    company1_phone: validations_1.mandatory,
    company1_address: validations_1.mandatory,
    company1_supervisor: validations_1.mandatory,
    company1_job_title: validations_1.mandatory,
    company1_starting_salary: validations_1.money,
    company1_ending_salary: validations_1.money,
    company1_responsabilities: validations_1.mandatory,
    company1_from: __assign(__assign({}, validations_1.mandatory), validations_1.date),
    company1_to: function (value, attributes) {
        return __assign(__assign({}, validations_1.mandatory), { datetime: __assign(__assign({}, datetime), { earliest: moment_1.default(attributes.company1_from) }) });
    },
    company1_reason_for_leaving: validations_1.mandatory,
    company1_might_contact_advisor: validations_1.radioButton
};
var EmploymentList = (function (_super) {
    __extends(EmploymentList, _super);
    function EmploymentList(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.employments = [
            {
                id: "company1",
                required: true
            },
            {
                id: "company2",
                required: false
            },
            {
                id: "company3",
                required: false
            }
        ];
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    EmploymentList.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    EmploymentList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateEmployment", this.isValid);
                return [2];
            });
        });
    };
    EmploymentList.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateEmployment");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    EmploymentList.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    EmploymentList.prototype.isValid = function () {
        console.log("Validate Education");
        rules = validations_1.checkDates("company2_from", "company2_to", this.json_data, rules);
        rules = validations_1.checkDates("company3_from", "othcompany3_toer_college_to", this.json_data, rules);
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        return isValid;
    };
    EmploymentList.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        validate_js_1.default.extend(validate_js_1.default.validators.datetime, {
            parse: function (value, options) {
                return +moment_1.default.utc(value);
            },
            format: function (value, options) {
                var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
                return moment_1.default.utc(value).format(format);
            }
        });
        var rulesDates = {};
        this.employments.forEach(function (e) {
            if (e.required) {
                rulesDates[e.id + "_to"] = {
                    presence: true,
                    datetime: {
                        dateOnly: true,
                        earliest: moment_1.default(json_data[e.id + "_from"]),
                        message: "Invalid date"
                    }
                };
                rules = Object.assign(rules, rulesDates);
            }
        });
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "PREVIOUS EMPLOYMENT"),
            this.employments.map(function (ed) { return (React.createElement(EmploymentItem_1.EmploymentItem, { key: ed.id, id: ed.id, required: ed.required, json_data: json_data, onChange: onChange, errors: errors })); })));
    };
    __decorate([
        mobx_1.observable
    ], EmploymentList.prototype, "errors", void 0);
    EmploymentList = __decorate([
        mobx_react_1.observer
    ], EmploymentList);
    return EmploymentList;
}(react_1.Component));
exports.EmploymentList = EmploymentList;
//# sourceMappingURL=data:application/json;base64,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